<template>
    <div class="order-item-option">
        <div class="order-item-option-details">
            <div class="order-item-option-name">
                <div class="quantity" v-if="option.quantity > 1">{{ option.quantity }}x</div>
                {{ getNameInLocationLanguage(option, props.showInternalNames) }}<ItemIcons v-if="option.articleId" :articleId="option.articleId" />
            </div>
            <div class="order-item-option-price">
                <ItemPrice
                    v-if="option.unitPrice > 0"
                    class="order-item-option-price"
                    :hasDiscount="option.hasDiscount"
                    :quantity="nextMultiplier"
                    :unitPrice="option.unitPrice"
                    :unitPriceAfterDiscount="option.unitPriceAfterDiscount"
                    :discountType="option.lastDiscountType"
                />
            </div>
        </div>
        <div class="subs" v-if="option.options.length">
            <OrderItemOptionGroup
                v-for="optionGroup in option.options"
                :key="optionGroup.id"
                :optionGroup="optionGroup"
                :multiplier="nextMultiplier"
                :showInternalNames="props.showInternalNames"
                :alwaysShowGroupName="props.alwaysShowGroupName"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { IOrderItem } from "@/data/model/Order";
    import { getNameInLocationLanguage } from "@/shared/helpers/ItemNameHelper";
    import { computed } from "vue";

    import ItemIcons from "@/components/order/ItemIcons.vue";
    import ItemPrice from "@/components/order/ItemPrice.vue";
    import OrderItemOptionGroup from "@/components/order/OrderItemOptionGroup.vue";

    const props = defineProps<{
        option: IOrderItem;
        multiplier: number;
        showInternalNames: boolean;
        alwaysShowGroupName?: boolean;
    }>();

    const nextMultiplier = computed(() => props.multiplier * props.option.quantity);
</script>

<style scoped lang="scss">
    @use "./../../../assets/styles/scss/shared/_colors.scss";
    @use "./../../../assets/styles/scss/shared/_variables.scss";

    .order-item-option {
        font-size: 12px;
        line-height: 1.666em;

        > .order-item-option-details {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: space-between;
            align-items: center;

            > .order-item-option-name {
                > .quantity {
                    display: inline-block;
                    vertical-align: top;
                    padding-right: 0.25em;
                    font-weight: 600;
                }

                flex-grow: 1;
            }

            > .order-item-option-price {
                flex: 0 0 auto;
            }
        }
        > .subs {
            padding: 0.1666em 0;
            padding-left: 1em;
        }
    }
</style>
